export interface UserActivityLogResult {
    currentPage: number,
    totalItems: number,
    totalPages: number,
    items: UserActivityLog[]
}

export interface UserActivityLog {
    userId: string,
    user: string,
    impersonatingUser: string,
    action: string,
    type: string,
    target: string,
    related: string,
    timeStampOnUtc: string,
    isBackdoorUser: boolean
    isUserDeleted: boolean
}
export interface UserActivityLogFilter{
    user: string,
    action: string,
    entityType: string,
    entityName: string,
    entityId: string,
    related: string,
    limitPerPage: number,
    currentPage: number,
    sortBy: string,
    isDescending: boolean,
    fromDate: string,
    toDate: string,
    searchQuery:string
}

export enum UserActivityLogType{
    Insert,
    Update,
    Delete,
    UnasignedUser,
    UnasignedUserGroup,
    UnasignedPlayer,
    UnasignedPowerPlan,
    UnasignedDesign,
    SignIn
}
